import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./App.css";
import AuthProvider, { useAuth } from "./contexts/AuthContext";
import Frontend from "./Components/frontend/Frontend";
import Backend from "./Components/backend/Backend";
import UserType from "./Components/userType";
import OwnerDashboard from "./Components/OwnerDashboard";
import About from "./Components/About";
import ReferralProgram from "./Components/ReferralProgram";
import Settings from "./Components/backend/Settings";
import Search from "./Components/Search";
import SignupOwner from "./Components/SignupOwner";
import SignupReferral from "./Components/SignupReferral";
import Login from "./Components/login";
import AuthLayout from "./Components/Auth/AuthLayout";
import Bookings from "./Components/backend/Bookings";
import SignupRenter from "./Components/SignupRenter";
import CreateListing from "./Components/createListing";
import Payments from "./Components/backend/Payments";
import MyListings from "./Components/backend/MyListings";
import AddListing from "./Components/backend/AddListing";
import Inbox from "./Components/Inbox";
import AdminInbox from "./Components/backend/AdminInbox";
import Users from "./Components/backend/Users";
import AddUser from "./Components/backend/AddUser";
import Profile from "./Components/backend/Profile";
import RenterProfile from "./Components/backend/RenterProfile";
import ChatBox from "./Components/ChatBox";
import ThankYou from "./Components/ThankYou";
import Listing from "./Components/backend/Listing";
import FrontEndListings from "./Components/backend/FrontEndListings";
import SingleListing from "./Components/SingleListing";
import ListingPackages from "./Components/ListingPackages";
import ListingDetail from "./Components/frontend/ListingDetail";
import { getUserByID } from "./Components/utils";
import { useEffect, useState } from "react";
import PendingApproval from "./Components/frontend/PendingApproval";
import User from "./Components/backend/User";
import BookingPayment from "./Components/backend/BookingPayment";
import Email from "./Components/backend/Email";
import Waivers from "./Components/backend/Waivers";
import AddWaiver from "./Components/backend/AddWaiver";
import Checklist from "./Components/Checklist";
import BoatOwners from "./Components/backend/BoatOwners";
import Event from "./Components/backend/Event";
import StartTrip from "./Components/backend/StartTrip";
import EndTrip from "./Components/backend/EndTrip";
// import EditBooking from "./Components/backend/EditBooking";
import Listings from "./Components/backend/Listings";
import Disputes from "./Components/backend/Disputes";
import Pricings from "./Components/frontend/Pricings";
import FAQ from "./Components/frontend/FAQ";
import ContactUs from "./Components/frontend/ContactUs";
import Withdrawal from "./Components/backend/Withdrawal";
import PaymentsDashboard from "./Components/backend/PaymentsDashboard";
import OwnerPaymentDetails from "./Components/backend/OwnerPaymentDetails";
import GetVerified from "./Components/frontend/GetVerified";
import TripWaivers from "./Components/backend/TripWaivers";
import AdultWaiver from "./Components/backend/AdultWaiver";
import MinorWaiver from "./Components/backend/MinorWaiver";
import Cancellation from "./Components/frontend/Cancellation";
import LaunchLoadChecklists from "./Components/frontend/LaunchLoadChecklists";
import PendingListings from "./Components/backend/PendingListings";
import PendingUsers from "./Components/backend/PendingUsers";
import PendingBoatOwners from "./Components/backend/PendingBoatOwners";
import BecomePro from "./Components/backend/BecomePro";
import PendingProMembers from "./Components/frontend/PendingProMembers";
import PrivacyPolicy from "./Components/frontend/PrivacyPolicy";
import CookiePolicy from "./Components/frontend/CookiePolicy";
import AccountDeletion from "./Components/frontend/AccountDeletion";
import ClientRelationship from "./Components/frontend/ClientRelationship";
import RejectedApproval from "./Components/frontend/RejectedApproval";
import EditWaiver from "./Components/backend/EditWaiver";
import Boats from "./Components/frontend/Boats";
import RejectedListings from "./Components/backend/RejectedListings";
import Coupons from "./Components/backend/Coupons";
import ReferralCodes from "./Components/backend/ReferralCodes";
import WaiverThankYou from "./Components/frontend/WaiverThankYou";
import MyWaiver from "./Components/frontend/MyWaiver";
import MyWaiverForm from "./Components/frontend/MyWaiverForm";
import StartTripWrapped from "./Components/backend/StartTripWrapped";
import ViewFillWaivers from "./Components/frontend/ViewFillWaivers";
import DemoBookingPayment from "./Components/backend/DemoBookingPayment";
import ForgotPassword from "./Components/ForgotPassword";
import HowTo from "./Components/frontend/HowTo";
import Tip from "./Components/backend/Tip";
import DatepickerCompo from "./Components/DatepickerCompo";
import How from "./Components/backend/How";
import GetUserVerified from "./Components/backend/GetUserVerified";
import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ZendeskConfig from "./zendesk.config";
import ChatBot from "./Components/CustomChatBot";
import AllListings from "./Components/frontend/AllListings";
import DownloadApp from "./Components/DownloadApp";
import AllEvents from "./Components/backend/AllEvents";
import { FormProvider } from "./contexts/FormContext";
import { SearchFilterProvider } from "./contexts/SearchFilterContext";
import RoleRoute from "./Components/RoleRoute";
import BlogPage from "./Components/frontend/BlogPage.js";
import BlogDetail from "./Components/frontend/BlogDetail.js";
import BlogList from "./Components/backend/BlogList.js";
import BlogCreate from "./Components/backend/BlogCreate.js";
import BlogEdit from "./Components/backend/BlogEdit.js";
import "./Components/frontend/Blog.css";

// Community Platform Imports
import CommunityHome from "./Components/frontend/community/CommunityHome";
import CategoryView from "./Components/frontend/community/CategoryView";
import ThreadDetail from "./Components/frontend/community/ThreadDetail";
import CreateThread from "./Components/frontend/community/CreateThread";
import CommunitySearch from "./Components/frontend/community/CommunitySearch";
import CommunityProfile from "./Components/frontend/community/CommunityProfile";
import LakeHub from "./Components/frontend/community/LakeHub";
import LakeDetail from "./Components/frontend/community/LakeDetail";

// Dashboard Community Pages
import MyCommunityDashboard from "./Components/backend/community/MyCommunityDashboard";
import VerifiedOperatorForum from "./Components/backend/community/VerifiedOperatorForum";
import ApplyVerifiedOperator from "./Components/backend/community/ApplyVerifiedOperator";
import TrustLevelProgress from "./Components/backend/community/TrustLevelProgress";

// Admin Community Pages
import AdminModerationQueue from "./Components/backend/community/admin/AdminModerationQueue";
import AdminOperatorReviews from "./Components/backend/community/admin/AdminOperatorReviews";
import AdminCommunityManager from "./Components/backend/community/admin/AdminCommunityManager";
import AdminLakeTournaments from "./Components/backend/community/admin/AdminLakeTournaments";
import AdminAIConfig from "./Components/backend/community/admin/AdminAIConfig";
import AdminContentEngine from "./Components/backend/community/admin/AdminContentEngine";
import AdminAllDiscussions from "./Components/backend/community/admin/AdminAllDiscussions";
import ListBoatForIncome from "./Components/frontend/ListBoatForIncome.js";
import ListFishingCharter from "./Components/frontend/ListFishingCharter.js";
import BoatOwnerBoats from "./Components/frontend/BoatOwnerBoats.js";
import ScanRedirect from "./Components/ScanRedirect.js";
import QRAnalytics from "./Components/backend/QRAnalytics.js";
import AdminNotifications from "./Components/backend/AdminNotifications.js";
import OwnerNotifications from "./Components/backend/OwnerNotifications.js";

// Role constants for route protection
const ADMIN = "Admin";
const OWNER = "Boat Owner";
const PRO = "Pro Staff";
const RENTER = "Renter";
const ADMIN_ONLY = [ADMIN];
const OWNER_AND_ADMIN = [ADMIN, OWNER, PRO];
const RENTER_AND_ADMIN = [ADMIN, RENTER];
const RENTER_AND_OWNER = [OWNER, RENTER];
const ALL_ROLES = [ADMIN, OWNER, PRO, RENTER];

function App() {
  const [userStatus, setUserStatus] = useState(null);

  function PrivateRoute({ children }) {
    const auth = useAuth();
    useEffect(() => {
      const fetchUserData = async () => {
        try {
          const userData = await getUserByID(auth.currentUser.uid);
          setUserStatus(userData.status);
        } catch (error) {
          // Handle error, e.g., redirect to an error page
          console.error("Error fetching user data", error);
        }
      };

      if (auth.currentUser) {
        fetchUserData();
      }
    }, [auth.currentUser]);

    if (!auth.currentUser) {
      // If user is not logged in, redirect to the login page
      return <Navigate to="/auth" />;
    }

    // if (userStatus === "Pending") {
    //   // If status is pending, redirect to the approval-pending page
    //   return <Navigate to="/approval-pending" />;
    // }

    // Allow access to the dashboard if user is logged in and status is not "Pending"
    return children;
  }

  function PublicRoute({ children }) {
    const auth = useAuth();
    return auth.currentUser && !auth.isSigningUp ? <Navigate to="/dashboard" /> : children;
  }

  // function PublicRoute({ children }) {
  //   const auth = useAuth();
  //   return auth.currentUser && userStatus === 'Pending' ? <Navigate to="/dashboard" /> : children;
  // }
  console.log("Zendesk Widget Implemented");
  return (
    <AuthProvider>
      {/* <ZendeskConfig /> */}
      <ChatBot />

      <FormProvider>
        <SearchFilterProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Frontend />}>
                <Route index element={<Boats />} />
                <Route path="listings" element={<Navigate to="/" replace />} />
                <Route path="tip/:dynamicId" element={<Tip />} />
                <Route path="about" element={<About />} />
                <Route path="referral-program" element={<ReferralProgram />} />
                <Route path="faq" element={<FAQ />} />
                <Route path="pricing" element={<Pricings />} />
                <Route path="contact" element={<ContactUs />} />
                <Route path="send-email" element={<Email />} />
                <Route path="thank-you" element={<ThankYou />} />
                <Route path="ListingDetail" element={<ListingDetail />} />
                <Route path="how-it-works" element={<HowTo />} />
                <Route path="boats" element={<Listings />} />
                <Route path="privacy-policy" element={<PrivacyPolicy />} />
                <Route path="cookie-policy" element={<CookiePolicy />} />
                <Route path="account-deletion" element={<AccountDeletion />} />
                <Route path="download-app" element={<DownloadApp />} />
                <Route
                  path="client-relationship"
                  element={<ClientRelationship />}
                />
                <Route path="cancellation" element={<Cancellation />} />
                <Route
                  path="launch-load-checklists"
                  element={<LaunchLoadChecklists />}
                />
                <Route path="listing/:dynamicId" element={<SingleListing />} />
                <Route path="boat-owner/:ownerId" element={<BoatOwnerBoats />} />
                <Route path="listing/:dynamicId/packages" element={<ListingPackages />} />
                <Route path="boat-listings" element={<FrontEndListings />} />
                <Route path="approval-pending" element={<PendingApproval />} />
                <Route path="approval-rejected" element={<RejectedApproval />} />
                <Route path="get-verified" element={<GetVerified />} />
                <Route
                  path="waivers/adultWaiver/:dynamicId"
                  element={<AdultWaiver />}
                />
                <Route path="my-waiver/:dynamicId" element={<MyWaiver />} />
                <Route path="my-waiver" element={<MyWaiverForm />} />
                <Route
                  path="waivers/minorWaiver/:dynamicId"
                  element={<MinorWaiver />}
                />
                <Route path="waivers/thank-you" element={<WaiverThankYou />} />
                <Route path="waivers/view-waivers" element={<ViewFillWaivers />} />
                <Route path="datepicker" element={<DatepickerCompo />} />
                <Route path="blog" element={<BlogPage />} />
                <Route path="blog/:slug" element={<BlogDetail />} />
                <Route path="list-my-boat" element={<ListBoatForIncome />} />
                <Route path="list-my-charter" element={<ListFishingCharter />} />
                {/* Community Platform Routes */}
                <Route path="community" element={<CommunityHome />} />
                <Route path="community/search" element={<CommunitySearch />} />
                <Route path="community/c/:categorySlug" element={<CategoryView />} />
                <Route path="community/thread/:threadId" element={<ThreadDetail />} />
                <Route path="community/new" element={<CreateThread />} />
                <Route path="community/edit/:editId" element={<CreateThread isEditMode={true} />} />
                <Route path="community/user/:userId" element={<CommunityProfile />} />
                <Route path="community/lakes" element={<LakeHub />} />
                <Route path="community/lakes/:lakeSlug" element={<LakeDetail />} />
              </Route>
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <Backend />
                  </PrivateRoute>
                }
              >
                {/* === All Roles (no RoleRoute needed) === */}
                <Route index element={<Bookings />} />
                <Route path="setting" element={<Settings />} />
                <Route path="bookings" element={<AllEvents />} />
                <Route path="payments" element={<Payments />} />
                <Route path="inbox" element={<Inbox />} />
                <Route path="renter/:userId" element={
                  <RoleRoute allowedRoles={OWNER_AND_ADMIN}><RenterProfile /></RoleRoute>
                } />
                <Route path="profile" element={<Profile />} />
                <Route path="thank-you" element={<ThankYou />} />
                <Route path="event/:dynamicId" element={<Event />} />
                <Route path="booking-payment" element={<BookingPayment />} />
                
                {/* Community Dashboard Routes */}
                <Route path="community" element={<MyCommunityDashboard />} />
                <Route path="community/operator-forum" element={<VerifiedOperatorForum />} />
                <Route path="community/apply-operator" element={<ApplyVerifiedOperator />} />
                <Route path="community/trust-levels" element={<TrustLevelProgress />} />
                
                {/* Admin Community Routes */}
                <Route path="community/admin/moderation" element={<RoleRoute allowedRoles={['Admin']}><AdminModerationQueue /></RoleRoute>} />
                <Route path="community/admin/categories" element={<RoleRoute allowedRoles={['Admin']}><AdminCommunityManager /></RoleRoute>} />
                <Route path="community/admin/operator-reviews" element={<RoleRoute allowedRoles={['Admin']}><AdminOperatorReviews /></RoleRoute>} />
                <Route path="community/admin/tournaments" element={<RoleRoute allowedRoles={['Admin']}><AdminLakeTournaments /></RoleRoute>} />
                <Route path="community/admin/ai-config" element={<RoleRoute allowedRoles={['Admin']}><AdminAIConfig /></RoleRoute>} />

                {/* === Owner + Admin Only === */}
                <Route path="my-listings" element={
                  <RoleRoute allowedRoles={OWNER_AND_ADMIN}><MyListings /></RoleRoute>
                } />
                <Route path="add-listing/for/:ownerId" element={
                  <RoleRoute allowedRoles={['Admin']}><AddListing /></RoleRoute>
                } />
                <Route path="add-listing" element={
                  <RoleRoute allowedRoles={OWNER_AND_ADMIN}><AddListing /></RoleRoute>
                } />
                <Route path="listing/:dynamicId" element={
                  <RoleRoute allowedRoles={OWNER_AND_ADMIN}><Listing /></RoleRoute>
                } />
                <Route path="pro-staff" element={
                  <RoleRoute allowedRoles={OWNER_AND_ADMIN}><BecomePro /></RoleRoute>
                } />
                <Route path="how" element={
                  <RoleRoute allowedRoles={OWNER_AND_ADMIN}><How /></RoleRoute>
                } />
                <Route path="withdrawals" element={
                  <RoleRoute allowedRoles={OWNER_AND_ADMIN}><Withdrawal /></RoleRoute>
                } />
                <Route path="startTrip/:dynamicId" element={
                  <RoleRoute allowedRoles={ALL_ROLES}><StartTripWrapped /></RoleRoute>
                } />
                <Route path="endTrip/:dynamicId" element={
                  <RoleRoute allowedRoles={OWNER_AND_ADMIN}><EndTrip /></RoleRoute>
                } />
                <Route path="waivers/:dynamicId" element={
                  <RoleRoute allowedRoles={OWNER_AND_ADMIN}><TripWaivers /></RoleRoute>
                } />
                <Route path="demo-booking-payment" element={
                  <RoleRoute allowedRoles={OWNER_AND_ADMIN}><DemoBookingPayment /></RoleRoute>
                } />

                {/* === Renter + Admin Only === */}
                <Route path="get-verified" element={
                  <RoleRoute allowedRoles={RENTER_AND_ADMIN}><GetUserVerified /></RoleRoute>
                } />

                {/* === Admin Only === */}
                <Route path="all-listings" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><AllListings /></RoleRoute>
                } />
                <Route path="disputes" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><Disputes /></RoleRoute>
                } />
                <Route path="admin-messages" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><AdminInbox /></RoleRoute>
                } />
                <Route path="users" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><Users /></RoleRoute>
                } />
                <Route path="user/:dynamicId" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><User /></RoleRoute>
                } />
                <Route path="boat-owners" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><BoatOwners /></RoleRoute>
                } />
                <Route path="boat-owners/:dynamicId" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><User /></RoleRoute>
                } />
                <Route path="add-user" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><AddUser /></RoleRoute>
                } />
                <Route path="pending-listings" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><PendingListings /></RoleRoute>
                } />
                <Route path="rejected-listings" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><RejectedListings /></RoleRoute>
                } />
                <Route path="pending-renters" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><PendingUsers /></RoleRoute>
                } />
                <Route path="pending-boat-owners" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><PendingBoatOwners /></RoleRoute>
                } />
                <Route path="pending-pro-members" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><PendingProMembers /></RoleRoute>
                } />
                <Route path="coupons" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><Coupons /></RoleRoute>
                } />
                <Route path="referral-codes" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><ReferralCodes /></RoleRoute>
                } />
                <Route path="waivers" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><Waivers /></RoleRoute>
                } />
                <Route path="add-waiver" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><AddWaiver /></RoleRoute>
                } />
                <Route path="edit-waiver/:dynamicId" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><EditWaiver /></RoleRoute>
                } />
                <Route path="blog" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><BlogList /></RoleRoute>
                } />
                <Route path="blog/create" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><BlogCreate /></RoleRoute>
                } />
                <Route path="blog/edit/:dynamicId" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><BlogEdit /></RoleRoute>
                } />
                <Route path="payments-dashboard" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><PaymentsDashboard /></RoleRoute>
                } />
                <Route path="payments-dashboard/:dynamicId" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><OwnerPaymentDetails /></RoleRoute>
                } />
                <Route path="qr-analytics" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><QRAnalytics /></RoleRoute>
                } />
                {/* Admin Community Routes */}
                <Route path="community/moderation" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><AdminModerationQueue /></RoleRoute>
                } />
                <Route path="community/all-discussions" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><AdminAllDiscussions /></RoleRoute>
                } />
                <Route path="community/operator-reviews" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><AdminOperatorReviews /></RoleRoute>
                } />
                <Route path="community/manage" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><AdminCommunityManager /></RoleRoute>
                } />
                <Route path="community/lakes-tournaments" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><AdminLakeTournaments /></RoleRoute>
                } />
                <Route path="community/ai-config" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><AdminAIConfig /></RoleRoute>
                } />
                <Route path="community/content-engine" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><AdminContentEngine /></RoleRoute>
                } />
                <Route path="notifications" element={
                  <RoleRoute allowedRoles={ADMIN_ONLY}><AdminNotifications /></RoleRoute>
                } />
                <Route path="my-notifications" element={
                  <RoleRoute allowedRoles={RENTER_AND_OWNER}><OwnerNotifications /></RoleRoute>
                } />
              </Route>
              
              {/* Standalone QR Redirect Route without generic Header/Footer */}
              <Route path="/start" element={<ScanRedirect />} />

              <Route
                path="/auth"
                element={
                  <PublicRoute>
                    <AuthLayout />
                  </PublicRoute>
                }
              >
                <Route
                  index
                  element={
                    <PublicRoute>
                      <Login />
                    </PublicRoute>
                  }
                />
                <Route
                  path="forgot-password"
                  element={
                    <PublicRoute>
                      <ForgotPassword />
                    </PublicRoute>
                  }
                />
                <Route
                  path="signup-owner"
                  element={
                    <PublicRoute>
                      <SignupOwner />
                    </PublicRoute>
                  }
                />
                <Route
                  path="signup-referral"
                  element={
                    <PublicRoute>
                      <SignupReferral />
                    </PublicRoute>
                  }
                />
                <Route
                  path="signup-renter"
                  element={
                    <PublicRoute>
                      <SignupRenter />
                    </PublicRoute>
                  }
                />
              </Route>
            </Routes>
            <ToastContainer
              position="top-center"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
            />
          </Router>
        </SearchFilterProvider>
      </FormProvider>
    </AuthProvider>
  );
}

export default App;
